var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.series.length && _vm.antiguedades.length)?_c('apexchart',{key:_vm.chartKey,attrs:{"type":"bar","height":"500","options":_vm.chartOptions,"series":_vm.series}}):_c('div',{staticClass:"text-center p-4 text-grey"},[_vm._v("\n    No hay datos de antigüedad disponibles\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }